import React from 'react'
import PropTypes from "prop-types"
import withStyles from '@material-ui/core/styles/withStyles'

import AppBar from '@material-ui/core/AppBar'
import clsx from 'clsx'
import { injectIntl } from 'react-intl'
import HorizontalMenu from './HorizontalMenu'
import MobileMenu from './MobileMenu'
import EmptyMenu from './EmptyMenu'
import menuItems from '../../constants/menuItems'

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.common.white
  },
  menuList: {
    display: 'flex',
    margin: 0
  }
})

const PureHeader = ({
  classes,
  className,
  intl,
  menuItems,
  isEmpty,
  isEloThemeActive,
  ...props
}) => {
  const parsedMenuItems = menuItems.map(menuItem => {
    if (menuItem.hasOwnProperty('i18nSectionId')) {
      const anchorKey = intl.formatMessage({ id: menuItem.i18nSectionId })

      menuItem.href = `#${anchorKey}`
    }

    return menuItem
  })

  return (
    <AppBar
      id="header"
      className={clsx(classes.root, className)}
      color="inherit"
      data-gtm-category="landing_header"
      data-gtm-label="bloco_header"
      data-gtm-main-action="view"
      data-gtm-category-ga4="landing_header"
      data-gtm-label-ga4="block_header"
      data-gtm-main-action-ga4="view"
      data-testid="app-bar"
      direction="row"
      elevation={0}
      itemScope={true}
      itemType="http://schema.org/WPHeader"
      position="fixed"
      style={{height: '58px'}}
    >
      {!isEmpty ? (
        <>
          <MobileMenu menuItems={parsedMenuItems} {...props} />
          <HorizontalMenu menuItems={parsedMenuItems} isEloThemeActive={isEloThemeActive} {...props} />
        </>
      ) : (
        <EmptyMenu {...props} />
      )}
    </AppBar>
  )
}

PureHeader.propTypes = {
  isEmpty: PropTypes.bool,
  menuItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    i18nSectionId: PropTypes.string,
    label: PropTypes.string,
    gtmLabel: PropTypes.string,
    href: PropTypes.string,
  })),
  isEloThemeActive: PropTypes.bool,
}

PureHeader.defaultProps = {
  menuItems: menuItems,
  isEmpty: false,
  isEloThemeActive: false,
}

const Header = withStyles(styles)(injectIntl(PureHeader))

export default Header
